import ConteosInicializacionConFoto from "../../../inventarios/toma/ConteosInicializacionConFoto";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil";

export default function ConteosInicializacionConFotoPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="ConteosInicializacionConFoto">
      <ConteosInicializacionConFoto />
    </SizeSoftXFrmPortatil>
  );
}
